/*
 * Copyright (c) 2024. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../../basic-entity-back/annotations";
import {PropertyType} from "../../../basic-entity-back/property-type/property-type";
import {BaseEntity} from "../../base-entity.model";

@BasicEntity({
    name: 'Cuenta bancaria',
    endpoint: 'cuenta_bancarias',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'iban',
    type: 'CuentaBancaria'
})
export class CuentaBancaria extends BaseEntity {

    @BasicProperty({
        isId: true,
        name: 'ID',
        type: PropertyType.Integer()
    })
    private _id: number;

    @BasicProperty({
        name: 'Descripción',
        type: PropertyType.String(),
    })
    private _descripcion: string;

    @BasicProperty({
        name: 'IBAN',
        type: PropertyType.String(0, 34),
    })
    private _iban: string;

    @BasicProperty({
        name: 'SWIFT/BIC',
        type: PropertyType.String(0, 11),
        nullable: true
    })
    private _swiftBic: string;

    get lectura(): string {
        return this._descripcion + ' - *******' + this._iban.substring(this.iban.length - 4);
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get descripcion(): string {
        return this._descripcion;
    }

    set descripcion(value: string) {
        this._descripcion = value;
    }

    get iban(): string {
        return this._iban;
    }

    set iban(value: string) {
        this._iban = value;
    }

    get swiftBic(): string {
        return this._swiftBic;
    }

    set swiftBic(value: string) {
        this._swiftBic = value;
    }

}
